const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

function useVerifyJwt() {
  const user = JSON.parse(localStorage.getItem("user"));

  let isExpire;
  if (user) {
    const decodedJwt = parseJwt(user.accessToken);

    isExpire = decodedJwt.exp * 1000 < Date.now();
  }

  return { isExpire };
}

export default useVerifyJwt;
